import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=a690e288&"
import script from "./columns.vue?vue&type=script&lang=js&"
export * from "./columns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports